export async function matchVendor(vendorName, {searchOrganizations, searchContacts}) {
    const organizationMatch = await searchOrganizations(vendorName);
    if (organizationMatch) {
        return {type: 'organization', match: organizationMatch};
    }

    const contactMatch = await searchContacts(vendorName);
    if (contactMatch) {
        return {type: 'contact', match: contactMatch};
    }

    return {type: null, match: null};
}
